<template>
  <div>
    <div class="page-form-header small-header">
      <h1>Privacy consent</h1>
    </div>
    <div class="page-form-content">
      <b-form-textarea id="textarea"
                       v-model="authAgreementText"
                       placeholder="Enter something..."
                       rows="10"
                       max-rows="10"></b-form-textarea>

      <v-form-group :validator="$v.profile.agreementAccepted">
        <b-form-checkbox class="pull-down"
                         id="agreementCheckbox"
                         v-model="profile.agreementAccepted"
                         name="agreementCheckbox">
          I consent that my personal health information (PHI) may be used to complete my order.
        </b-form-checkbox>
      </v-form-group>
    </div>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";
  import registrationAgreement from "../../../../store/constants/registration-agreement";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('profile');

  export default {
    mixins: [formMixin],

    data() {
      return {
        authAgreementText: registrationAgreement.text,
      };
    },

    validations: {
      profile: {
        agreementAccepted: {
          required
        }
      }
    },

    computed: {
      ...mapState(["profile"])
    },

    created() {
      this.profile.agreementAccepted = false;
    }
  };
</script>